import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, BRAND } from "@/lib/divine";
import { LogIn } from "lucide-react";

export default function AdminLogin() {
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/admin/login", { password });
      localStorage.setItem("divine_admin_token", data.token);
      toast.success("Welcome back.");
      navigate("/admin");
    } catch {
      toast.error("Incorrect password.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen flex items-center justify-center bg-white px-6">
      <form onSubmit={submit} className="w-full max-w-md border border-black/10 bg-[#FAF7F0] p-10">
        <img src={BRAND.logoIcon} alt="" className="h-12 w-12 mb-6" />
        <div className="overline mb-2">Admin Access</div>
        <h1 className="font-serif text-3xl md:text-4xl mb-8">Sign in</h1>

        <label className="overline block mb-2">Password</label>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          data-testid="admin-password"
          autoFocus
          placeholder="••••••••"
          className="w-full bg-transparent border-b border-black/15 focus:border-[#D4A437] outline-none py-3 text-lg text-[#0A0A0A]"
        />

        <button
          type="submit"
          disabled={loading || !password}
          data-testid="admin-login-btn"
          className="btn-gold w-full mt-10 justify-center disabled:opacity-60"
        >
          {loading ? "Signing in..." : "Sign In"} <LogIn className="w-4 h-4" strokeWidth={1.5} />
        </button>
      </form>
    </div>
  );
}
